/*eslint-disable max-len*/
/*eslint-disalbe no-case-declarations*/

import React, { PropTypes } from 'react'
import { connect } from 'react-redux'
import * as loader from 'loader'
import { components, consts, utils, Actions, Translate } from 'unity-core'
const { NavLink } = components
import { ModuleLoader } from 'components'
import classnames from 'classnames'
const { Routes } = consts
import shortid from 'shortid'
const { regexUtils, accessControlUtils } = utils
import { bindActionCreators } from 'redux'
import { Scrollbars } from 'react-custom-scrollbars'
import jwtDecode from 'jwt-decode'

const propTypes = {
	strings: PropTypes.object.isRequired,
	children: PropTypes.element.isRequired, //Comes from react-router as the active user link
	location: PropTypes.string,
	module: PropTypes.string,
	path: PropTypes.string,
	permissions: PropTypes.object.isRequired,
	searchCache: PropTypes.shape({ clearCacheWithReinit: PropTypes.func.isRequired }).isRequired,
	modules: PropTypes.object.isRequired
}
const defaultProps = {
	path: '',
	module: ''
}

const Menu = (props) => {
	return <ul className="nav nav-pills nav-stacked">{props.tabs.map(tab => {
		let classes = classnames({ 'active': tab.href === props.path })
		let NavStyle = {
			//cursor: tab.href.includes(this.props.path) ? 'not-allowed' : 'pointer'	//ALLOW TAB TO BE RE-CLICKED
		}
		if (tab.external) {
			return (
				<li key={tab.id} role="presentation" className={classes}>
					<a href={tab.href} aria-controls="tab1" role="tab" data-toogle="tab" style={NavStyle}>
						<span className={tab.className}>{tab.title}</span>
					</a>
				</li>)
		}
		return (
			<li key={tab.id} role="presentation" className={classes}>
				<NavLink to={tab.href} aria-controls="tab1" role="tab" data-toogle="tab" style={NavStyle}>
					<span className={tab.className}>{tab.title}</span>
				</NavLink>
			</li>
		)
	})}</ul>
}

const UBETMenu = (props) => {
	const { strings } = props
	let tabs = []
	tabs = [
		{ id: shortid.generate(), title: strings.main, className: '', href: `${Routes.HOME}` },
		{ id: shortid.generate(), title: strings.UBET, className: 'slide-left-10', href: `${Routes.MODULES.UBET}` },
		{ id: shortid.generate(), title: strings.UBET_tabs.launcher, className: 'slide-left-20', href: `/${Routes.MODULES.UBET}/${Routes.UBET.launcher}` }
	]
	return <Menu {...props} tabs={tabs} />
}

const EmptyMenu = (props) => {
	const { strings } = props
	let tabs = []
	tabs = [
		{ id: shortid.generate(), title: strings.main, className: '', href: `${Routes.HOME}` },
	]
	return <Menu {...props} tabs={tabs} />
}

const MainMenu = (props) => {
	const { strings, user, permissions, modules, lang } = props;

	const getAppPerms = (user) => {
		const { token } = user;
		const details = jwtDecode(token)
		const { perms } = details;
		return perms;
	}

	const canAccessModule = (module, user, appPerms) => {
		return module.enabled && (
			(user.permissions[module.permission] && user.permissions[module.permission].app) ||
			(user.roles && _.find(user.roles, role => role.startsWith('USERMANAGER_SYSADMIN|'))) ||
			(appPerms && accessControlUtils.checkAccess(appPerms, `${module.permission}_APP`))
		)
	};
	let tabs = []
	tabs.push({ id: shortid.generate(), title: strings.main, className: '', href: `${Routes.HOME}` });
	const appPerms = getAppPerms(user);
	const accessibleModules = _.filter(modules, x => canAccessModule(x, user, appPerms));
	_.forEach(accessibleModules, m => {
		let res = loader.loadModule(m.bundle)
		if (m.external && m.externalApp)
			tabs.push({ id: shortid.generate(), title: m.name, className: 'slide-left-10', href: `/uappauth/app/${m.bundle}`, external: true })
		else if (m.external)
			tabs.push({ id: shortid.generate(), title: m.name, className: 'slide-left-10', href: `/${m.path}`, external: true })
		else if (res != null)
			tabs.push({ id: shortid.generate(), title: res.getName(), className: 'slide-left-10', href: `${m.path}` })
	})

	return <Menu {...props} tabs={tabs} />
}

const ModuleMenu = (props) => {
	return <ModuleLoader bundle={props.bundle} r={m => {
		if (m == null) {
			let tabs = []
			tabs.push({ id: shortid.generate(), title: props.strings.main, className: '', href: `${Routes.HOME}` })
			return <Menu {...props} tabs={tabs} />
		}
		else {
			const { Menu } = m
			return <Menu {...props} />
		}
	}} />
}

export class NavMenu extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			// tabs: []
		}
	}

	render() {
		const { module, modules } = this.props
		return (
			<div>
				<div className="container-fluid">
					<div id="left-hand-menu-2" className="dnb-left-hand-menu hidden-xs">
						<Scrollbars style={{ height: '100%' }}>
							{(() => {
								let menu = <EmptyMenu {...this.props} />
								if (module.toUpperCase() == Routes.HOME.toUpperCase()) {
									menu = <MainMenu {...this.props} />
								} else {
									_.map(_.filter(modules, x => x.enabled), m => {
										console.log(m)
										if (module.toUpperCase() == m.path.toUpperCase()) {
											// if (m.external && m.permission == 'UBET')
											// 	menu = <UBETMenu {...this.props} />
											// else
											menu = <ModuleMenu key={m.bundle} bundle={m.bundle} {...this.props} />
										}
									})
								}
								return menu
							})()}
						</Scrollbars>
					</div>
					<div className="clearfix dnb-right-hand-menu">
						<div className="clearfix container-fluid" role="main">
							{this.props.children}
						</div>
					</div>
				</div>
			</div>
		)
	}
}

NavMenu.propTypes = propTypes
NavMenu.defaultProps = defaultProps

const mapStateToProps = (store, ownProps) => {  //==> Comes from https://github.com/reactjs/react-router-redux#how-do-i-access-router-state-in-a-container-component

	const path = regexUtils.extractModulePathFromUrl(ownProps.router.location)
	const module = regexUtils.extractModuleNameFromUrl(ownProps.router.location)
	return {
		location: ownProps.router.location.pathname,
		module,
		path,
		permissions: store.user.permissions,
		lang: store.user.lang,
		modules: store.app.modules,
	}
}
const mapDispatchToProps = dispatch => ({
	searchCache: bindActionCreators({ clearCacheWithReinit: Actions.SearchCache.clearCacheWithReinit }, dispatch)
})

const decorators = _.flow([
	connect(mapStateToProps, mapDispatchToProps),
	Translate('menuLinks')
])

export default decorators(NavMenu)
